// src/Pages/Surprises/Surprises.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import './Surprises.scss';
import StripeCheckout from 'react-stripe-checkout';
import SubmitForm from '../../Component/SubmitForm/SubmitForm';
import Nav from '../../Component/Nav';
import Footer from '../../Component/Footer';

const FALLBACK_IMG =
  'https://res.cloudinary.com/dzytbkc5l/image/upload/v1762283491/DreamDate/404_kmeiro.svg';

function safeCategories(raw) {
  try {
    if (Array.isArray(raw)) return raw;
    if (typeof raw === 'string') {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    }
    return [];
  } catch {
    return [];
  }
}

function toNumber(x, def = 0) {
  const n = Number(x);
  return Number.isFinite(n) ? n : def;
}

export default function Surprises() {
  const [experiences, setExperiences] = useState([]);
  const [isFormVisible, setFormVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState('');

  const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

  useEffect(() => {
    const ac = new AbortController();

    (async () => {
      setLoading(true);
      setErr('');
      try {
        // ходим через Netlify Function-прокси
        const res = await fetch('/api/experiences', { signal: ac.signal });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();

        const filtered = (Array.isArray(data) ? data : [])
          .filter((exp) => {
            const cats = safeCategories(exp?.categories)
              .map((c) => String(c).trim().toLowerCase());
            return cats.includes('surprises');
          })
          .map((exp, i) => ({
            id: exp.id ?? exp._id ?? i,
            title: exp.title ?? exp.name ?? 'Experience',
            description: exp.description ?? '',
            imageUrl: exp.imageUrl ?? exp.img ?? FALLBACK_IMG,
            price: toNumber(exp.price, 0),
          }));

        setExperiences(filtered);
      } catch (e) {
        if (e.name !== 'AbortError') setErr(e.message || 'Failed to load');
      } finally {
        setLoading(false);
      }
    })();

    return () => ac.abort();
  }, []);

  const handleToken = (token, addresses) => {
    // TODO: отправлять token на ваш бекенд для создания PaymentIntent
    console.log('Stripe token:', token, addresses);
    alert('Payment Successful');
  };

  const grid = useMemo(() => (
    <div className="experiences__grid">
      {experiences.map((experience) => (
        <div className="experiences__card" key={experience.id}>
          <Link to={`/experience/${experience.id}`}>
            <img
              src={experience.imageUrl || FALLBACK_IMG}
              alt={experience.title}
              className="experiences__image"
              loading="lazy"
            />
          </Link>

          <h3 className="experiences__card-title">{experience.title}</h3>
          <p className="experiences__description">{experience.description}</p>

          {publishableKey ? (
            <StripeCheckout
              name="DreamyDates"
              billingAddress
              shippingAddress
              description={`Your total is $${experience.price}`}
              amount={Math.round(toNumber(experience.price, 0) * 100)}
              token={handleToken}
              stripeKey={publishableKey}
            >
              <button className="experiences__price">
                Price from ${experience.price}
              </button>
            </StripeCheckout>
          ) : (
            <button
              className="experiences__price"
              disabled
              title="Payments temporarily unavailable"
            >
              Price from ${experience.price}
            </button>
          )}
        </div>
      ))}
    </div>
  ), [experiences, publishableKey]);

  return (
    <div className="Surprises-page">
      <div className="backdrop-blur-sm p-4 z-10 relative">
        <Nav />
      </div>

      <div className="experiences">
        {isFormVisible && <SubmitForm onClose={() => setFormVisible(false)} />}

        <h2 className="experiences__title">
          Just choose an idea, the rest is our task
        </h2>

        {loading && <div className="experiences__loading">Loading…</div>}
        {err && !loading && (
          <div className="experiences__error">Couldn’t load experiences: {err}</div>
        )}
        {!loading && !err && grid}
      </div>

      <div className="backdrop-blur-sm p-4 z-10 relative">
        <Footer />
      </div>
    </div>
  );
}